import {CopyIcon} from '@sanity/icons'
import {Box, Button, Code, Flex, Label, Stack, useToast} from '@sanity/ui'
import {useCallback} from 'react'

import {useCopyToClipboard} from '@/utils/index'

type CopyIDProps = {
  label: string
  id: string
}

export function CopyID({label, id}: CopyIDProps) {
  const {push} = useToast()
  const {copyToClipboard} = useCopyToClipboard()

  const handleCopyToClipboard = useCallback(
    (id: string, label: string) => {
      copyToClipboard(id, {
        onSuccess: () => {
          push({
            title: `Copied ${label} to clipboard`,
            status: 'success',
          })
        },
        onError: () => {
          push({
            title: `Failed to copy ${label} to clipboard`,
            status: 'error',
          })
        },
      })
    },
    [copyToClipboard, push]
  )

  return (
    <Stack space={1}>
      <Label muted weight="medium">
        {label}
      </Label>
      <Flex align="center">
        <Code size={1}>{id}</Code>
        <Box>
          <Button
            fontSize={0}
            padding={2}
            icon={CopyIcon}
            tone="default"
            mode="bleed"
            onClick={() => handleCopyToClipboard(id, label)}
          />
        </Box>
      </Flex>
    </Stack>
  )
}
